import type { FlowDefinition, CreateFlowDefinition } from '@reflex/flows';

/**
 * Build a `CreateFlowDefinition` payload from an existing flow. Strips
 * server-managed fields (`id`, `enabled`, `system`, timestamps) and appends
 * "(copy)" to the name. Lives in its own module so unit tests can import it
 * without pulling React Query or socket dependencies.
 */
export function flowToCreatePayload(flow: FlowDefinition): CreateFlowDefinition {
  return {
    name: `${flow.name} (copy)`,
    ...(flow.description ? { description: flow.description } : {}),
    trigger: flow.trigger,
    ...(flow.inputSchema && flow.inputSchema.length > 0 ? { inputSchema: flow.inputSchema } : {}),
    nodes: flow.nodes,
    edges: flow.edges,
  };
}
